/* eslint-disable quotes */
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);

const routerPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error);
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/ExerciseDetail",
      name: "ExerciseDetail",
      component: () => import("@/views/exercise/index")
    },
    {
      path: "/ExerciseChoose",
      name: "ExerciseChoose",
      component: () => import("@/views/exercise/ExerciseChoose")
    },
    {
      path: "/ExerciseProgram",
      name: "ExerciseProgram",
      component: () => import("@/views/exercise/ExerciseProgram")
    },
    {
      path: "/ExerciseShortAnswer",
      name: "ExerciseShortAnswer",
      component: () => import("@/views/exercise/ExerciseShortAnswer")
    },
    {
      path: "/ExerciseAttachment",
      name: "ExerciseAttachment",
      component: () => import("@/views/exercise/ExerciseAttachment")
    },
    {
      path: "/ViewExerciseChoose",
      name: "ViewExerciseChoose",
      component: () => import("@/views/exercise/ViewExerciseChoose")
    },
    {
      path: "/ViewExerciseProgram",
      name: "ViewExerciseProgram",
      component: () => import("@/views/exercise/ViewExerciseProgram")
    },
    {
      path: "/ViewExerciseShortAnswer",
      name: "ViewExerciseShortAnswer",
      component: () => import("@/views/exercise/ViewExerciseShortAnswer")
    },
    {
      path: "/ViewExerciseAttachment",
      name: "ViewExerciseAttachment",
      component: () => import("@/views/exercise/ViewExerciseAttachment")
    },
    {
      path: "/ExerciseSuccess",
      name: "ExerciseSuccess",
      component: () => import("@/views/exercise/ExerciseSuccess")
    },
    {
      path: "/ExerciseConvicted",
      name: "ExerciseConvicted",
      component: () => import("@/views/exercise/ExerciseConvicted")
    },
    {
      path: "/Login",
      name: "Login",
      component: () => import("@/views/Login")
    },
    {
      path: "/Auth",
      name: "Auth",
      component: () => import("@/views/Auth")
    },
    {
      path: "/WxLogin",
      name: "WxLogin",
      component: () => import("@/views/WxLogin")
    },
    {
      path: "/MiddlePage",
      name: "MiddlePage",
      component: () => import("@/views/MiddlePage")
    },
    {
      path: "/",
      redirect: "Login"
    }
  ]
});

if (localStorage.getItem("token")) {
  store.commit("setToken", localStorage.getItem("token"));
}
router.beforeEach((to, from, next) => {
  if (to.path == "/login") {
    // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
    if (store.state.app.token) {
      next({
        path: "/ExerciseDetail",
        query: {
          exerciseCode: localStorage.getItem("exerciseCode")
        }
      });
    } else {
      if (to.query.t == undefined) {
        to.query.t = new Date().getTime();
        router.push({
          path: to.path,
          query: to.query
        });
        return;
      }
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js